import { SelectionModel } from "@angular/cdk/collections";
import { Component, input, output } from "@angular/core";
import { MatSortModule, Sort } from "@angular/material/sort";
import { GetInvoiceStatusDescription } from "../../../modals/invoice-modal/types/Invoice";
import { InvoiceSearchRow } from "../types/InvoiceSearchRow";
import { MatTableModule } from "@angular/material/table";
import { CommonModule } from "@angular/common";

@Component({
  selector: 'invoice-search-results',
  templateUrl: 'invoice-search-results-grid.component.html',
  standalone: true,
  imports: [MatTableModule, MatSortModule, CommonModule]
})
export class InvoiceSearchResultsGridComponent {
  public rows = input<InvoiceSearchRow[]>([]);
  public onEdit = output<InvoiceSearchRow>();
  public sortChanged = output<Sort>();

  protected selection = new SelectionModel<InvoiceSearchRow>(false);
  protected Columns: ("count" | keyof InvoiceSearchRow)[] = [
    "InvoiceNumber",
    "InvoiceYear",
    "VendorInvoiceDate",
    "DueDate",
    "PurchaseOrder",
    "PurchaseRequest",
    "count", // the only non-sortable column
    "TotalInvoiced",
    "InvoiceStatus",
    "CheckNumber",
    "PaidDate",
    "VendorName",
    "VendorCode",
    "VendorCountry",
  ];

  protected doubleClick(row: InvoiceSearchRow) {
    if (!this.selection.isSelected(row))
      this.selection.toggle(row);

    this.onEdit.emit(row);
  }

  protected onSortChange(evt: Sort) {
    this.sortChanged.emit(evt);
  }

  protected GetInvoiceStatusDescription = GetInvoiceStatusDescription;
}
